module.exports = __webpack_public_path__ + "static/media/iconClassesYellow.fc2372b7.svg";